import React from 'react'

const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)"'\]])/g

export function linkifyText(text: string): React.ReactNode[] {
  const parts = text.split(URL_REGEX)

  return parts.map((part, index) => {
    if (URL_REGEX.test(part)) {
      // Reset lastIndex since we're reusing the regex
      URL_REGEX.lastIndex = 0
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-tessan-primary hover:underline break-all"
        >
          {part}
        </a>
      )
    }
    return part
  })
}
